(ns ycweb.app.website.search.results
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.app.website.cards :as cards]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn feature-key? [filter-key]
  (or (str/starts-with? (name filter-key) "fs_") (str/starts-with? (name filter-key) "fn_")))

(defn build-selected-filters [filters config]
  (reduce
    (fn [acc [feature-key feature]]
      (let [selected-features
            (reduce
              (fn [a [k v]]
                (cond
                  (and (:selected? v) (= feature-key :category) (= (:key config) :category))
                  [(:value config)]

                  (and (:selected? v) (= feature-key :category2) (= (:key config) :category2))
                  [(:value config)]

                  (and (:selected? v) (= feature-key :brand) (= (:key config) :brand))
                  [(:value config)]

                  (:selected? v)
                  (conj a k)

                  :else
                  a))
              []
              (:links feature))]
        (if (empty? selected-features)
          acc
          (merge acc {feature-key selected-features}))))
    {}
    filters))

(defn build-search-config [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)

        {:search/keys [searchstr defined-base-page search-category result-size page-number]}
        (cmn/curact process-atom [:search])

        page-type (cmn/curact process-atom [:page-type])
        navigation-filters (cmn/curact process-atom [:navigation :navigation/filters])
        selected-filters (build-selected-filters navigation-filters config)
        navigation (cmn/curact process-atom [:navigation])]

    {:search
     #:search
      {:defined-base-page defined-base-page
       :search-category search-category}

     :page-type page-type
     :params (conj {:searchstr searchstr :sort (:navigation/sort navigation) :page page-number :rows result-size} selected-filters)}))

(defn transform-navigation-filters [filters]
  (let [feature-filters (u/index-by :key (:features filters))
        standard-filters (dissoc filters :features)]

    (->>
      (merge standard-filters feature-filters)
      (reduce
        (fn [acc [k v]]
          (assoc acc k (assoc v :links (u/index-by :value (:links v)))))
        {}))))

(defn swap-atom-search-results [app-atom e]
  (let [{:ent/keys [display-name]
         :search/keys
         [searchstr defined-base-page search-category search-suggestions page-meta-title result-size
          page-number products breadcrumbs]} (:search e)

        navigation-filters (transform-navigation-filters (:navigation/filters (:navigation e)))
        navigation (assoc (:navigation e) :navigation/filters navigation-filters)]

    (swap! (cmn/process-cursor app-atom) assoc
      :search
      #:search
       {:searchstr searchstr
        :ent/display-name display-name
        :defined-base-page defined-base-page
        :search-category search-category
        :search-suggestions search-suggestions
        :page-meta-title page-meta-title
        :result-size result-size
        :page-number page-number
        :products products
        :breadcrumbs breadcrumbs}
      :page-type (:page-type e)
      :search-banners (:banners e)
      :original-navigation navigation
      :navigation navigation)))

;; Filter Popup ========================================================================================================
(rum/defc remove-filter-item < rum/reactive [app-atom {:ent/keys [display-name] :as item}]
  [:<>
   [:span.current-filter__item-text display-name]
   [:a.current-filter__item-option
    {:on-click #(grid/dispatch-action app-atom :search/remove-filter-solr {:key (:remove-filter/key item) :value (:remove-filter/new-value item)})}
    [:i.current-filter__item-icon
     {:class (u/bem :icon [:close :medium :block])}
     [:span.u-hidden-from-view "- Remove this Filter"]]]])

(rum/defc filter-popup-body < rum/reactive [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        navigation-filter (rum/cursor-in process-atom [:navigation :navigation/filters])
        {:navigation/keys [remove-filters filters]} (cmn/curact process-atom [:navigation])
        filter-options (dissoc filters :category2)]

    #?(:cljs
       (let [first-expanded-filter
             (->>
               (cmn/curact app-atom [:filter])
               (filter
                 #(:expanded? (second %)))
               (keys)
               (first))

             elem-name (when first-expanded-filter (if (feature-key? first-expanded-filter) "feature" (name first-expanded-filter)))
             elem (first (seq (.getElementsByClassName js/document (str "js-filter-" elem-name))))]
         (when elem
           (.scrollIntoView elem))))

    [:<>
     (when (> (count remove-filters) 0)
       (headings/heading "Current filters:" {:type :h2 :size :small}))
     (when (> (count remove-filters) 0)
       [:ul.current-filter
        (map
          (fn [item]
            [:li.current-filter__item
             {:key (:remove-filter/current-value item)}
             (remove-filter-item app-atom item)])
          remove-filters)])

     (headings/heading "Filter results by:" {:type :h2 :id "nav-filter" :size :small})
     (when filter-options
       (map
         (fn [{:keys [display-name links hide?] :as filter-option}]
           (let [filter-key (:key filter-option)
                 filter-expand-atom (rum/cursor-in app-atom [:filter filter-key])
                 filter-expanded? (:expanded? (rum/react filter-expand-atom))
                 filter-show-more? (:show-more? (rum/react filter-expand-atom))
                 links-count (count links)
                 brand-or-cat? (contains? #{:category :brand} filter-key)

                 links-sorted
                 (cond
                   brand-or-cat?
                   (->>
                     links
                     (sort-by (comp :display-name second))
                     (into (sorted-map)))

                   :else
                   links)

                 links
                 (if (and brand-or-cat? (not filter-show-more?))
                   (take 7 links-sorted)
                   links-sorted)]

             (when-not hide?
               [:nav.search-filter-wrapper
                {:id (str "filter-" (name filter-key))
                 :class
                 (if (feature-key? filter-key)
                   (str "js-filter-feature")
                   (str "js-filter-" (name filter-key)))}
                [:h3.search-filter-heading
                 [:a.search-filter-heading__link
                  (urlstate/href-on-click #(swap! filter-expand-atom update :expanded? not))
                  [:span.search-filter-heading__text display-name]
                  [:span.search-filter-heading__icon-wrapper
                   [:i.search-filter-heading__icon
                    {:class (u/bem :icon [(if filter-expanded? :minus :plus) :block])}
                    [:span.u-hidden-from-view "- Collapse this Section"]]]]]

                [:ul.search-filter
                 {:class (u/bem :search-filter [(when filter-expanded? :is-open)])}
                 (map
                   (fn [[_ link]]
                     (list
                       (when-not
                         (and (contains? #{:category :brand} filter-key) (:selected? link))
                         [:li.search-filter__item
                          {:key (name filter-key)}
                          [:label.checkbox-label
                           (forms/checkbox-raw
                             (rum/cursor-in navigation-filter [filter-key :links (:value link) :selected?])
                             {:change-fn #(grid/dispatch-action app-atom :search/filter-solr {:key filter-key :value (:value link)})
                              :pre-change-fn #(toaster/open-overlay app-atom :search/filter-refresh)})
                           [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
                           (:display-name link)]
                          [:a.search-filter__item-count
                           [:span.search-filter__item-count-text
                            (:count link)]]])))
                   links)

                 (when
                   (and (contains? #{:category :brand} filter-key) (> links-count 7))
                   [:li.sidebar-filter__more-item
                    [:a.search-filter__more-link
                     (urlstate/href-on-click #(swap! filter-expand-atom update :show-more? not))
                     "See " (if filter-show-more? "less " "more ") (if (= filter-key :category) "categories" "brands") "..."]])]])))
         (sort-by (juxt :priority :feature-name) (vals filter-options))))

     (toaster/loading-overlay app-atom :search/filter-refresh)]))

(rum/defc filter-popup-footer < rum/reactive [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        {:navigation/keys [result-count] :as navigation} (cmn/curact process-atom [:navigation])]
    (grid/row {:flush? true}
      (grid/cell {:span 1 :cols 2 :flush? true}
        (buttons/button "Cancel"
          #(do
             (grid/dispatch-action app-atom :search/revert-filter {})
             (grid/close-modal app-atom))
          {:full true :square-corners true :large true :secondary true}))
      (grid/cell {:span 1 :cols 2 :flush? true}
        (buttons/button (str "Show " result-count " results")
          #(grid/dispatch-action app-atom :search/apply-filter {})
          {:full true :square-corners true :large true})))))

(defmethod grid/modal-config :search/filter-popup [app-atom _ _]
  {:close-action? true
   :body filter-popup-body
   :footer filter-popup-footer
   :cancel-key :search/revert-filter})

(defmethod grid/action :search/filter-popup [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        navigation-filter (rum/cursor-in process-atom [:navigation :navigation/filters])
        preselected-filter (:filter-key config)

        feature-keys
        (->>
          @navigation-filter
          (keys)
          (filter
            #(or (str/starts-with? (name %) "fs_") (str/starts-with? (name %) "fn_"))))

        expanded-filters
        (cond
          (= preselected-filter :features)
          (reduce
            (fn [acc f]
              (assoc acc f {:expanded? true}))
            {}
            feature-keys)

          :else
          {preselected-filter {:expanded? true}})]

    (swap! app-atom
      #(->
         %
         (dissoc :filter)
         (assoc :filter expanded-filters)))

    (grid/open-modal app-atom :search/filter-popup
      {:scan ""
       :config
       {:title "Filter"}})))

(defn transform-send-params [filters]
  (reduce
    (fn [acc [k v]]
      (if (or (str/starts-with? (name k) "fs_") (str/starts-with? (name k) "fn_"))
        (assoc acc :features (concat (:features acc) [{:feature-key k :feature-value v}]))
        (assoc acc k v)))
    {}
    filters))

(defmethod grid/action :search/filter-solr [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)

        {:search/keys [searchstr defined-base-page search-category]}
        (cmn/curact process-atom [:search])

        page-type (cmn/curact process-atom [:page-type])
        navigation-filters (cmn/curact process-atom [:navigation :navigation/filters])
        selected-filters (build-selected-filters navigation-filters config)
        navigation (cmn/curact process-atom [:navigation])
        transformed-params (transform-send-params selected-filters)]

    (comms/ajax-post :web.search/filter-products
      {:search
       #:search
        {:defined-base-page defined-base-page
         :search-category search-category}
       :page-type page-type
       :params (conj {:searchstr searchstr :sort (:navigation/sort navigation)} transformed-params)})))

(defmethod comms/receive :web.search/filter-products [app-atom e]
  (let [navigation-filters (transform-navigation-filters (:navigation/filters (:navigation e)))
        navigation (assoc (:navigation e) :navigation/filters navigation-filters)]

    (toaster/close-overlay app-atom :search/filter-refresh)
    (swap! (cmn/process-cursor app-atom) assoc
      :navigation navigation)))

(defmethod grid/action :search/remove-filter-solr [app-atom config]
  (toaster/open-overlay app-atom :search/filter-refresh)
  (let [process-atom (cmn/process-cursor app-atom)

        {:search/keys [searchstr defined-base-page search-category]}
        (cmn/curact process-atom [:search])

        page-type (cmn/curact process-atom [:page-type])
        navigation-filters (cmn/curact process-atom [:navigation :navigation/filters])
        selected-filters (build-selected-filters navigation-filters config)

        transformed-params
        (transform-send-params (update-in selected-filters [(:key config)] #(:value config)))]

    (comms/ajax-post :web.search/filter-products
      {:search
       #:search
        {:defined-base-page defined-base-page
         :search-category search-category}

       :page-type page-type
       :params (conj {:searchstr searchstr} transformed-params)})))

(defmethod grid/action :search/apply-filter [app-atom config]
  (toaster/open-overlay app-atom :search/results)
  (grid/dispatch-modal-action app-atom :grid/single-input-modal-cancel)
  (let [search-config (build-search-config app-atom config)
        transformed-params (transform-send-params (dissoc (:params search-config) :page))]

    (comms/ajax-post :web.search/apply-filter
      (assoc search-config :params transformed-params))))

(defmethod comms/receive :web.search/apply-filter [app-atom e]
  (let [{:search/keys [page-meta-title] :as search} (:search e)
        url-params (:params (:url-navigation e))

        url-param-features
        (->>
          (:features url-params)
          (map
            (fn [p]
              {(:feature-key p) (:feature-value p)}))
          (into {}))]

    (swap-atom-search-results app-atom e)
    (toaster/close-overlay app-atom :search/results)

    (urlstate/navigate app-atom nil
      (urlstate/url
        (str "/" (:base (:url-navigation e)) ".htm")
        (merge (dissoc url-params :features) url-param-features)))

    #?(:cljs
       (do
         (when (u/presence page-meta-title)
           (set! (. js/document -title) page-meta-title))
        ;; We are using urlstate/navigate for now, because the below is giving history issues on first navigate. 
        ;; Using urlstate/navigate unfortunately will trigger a transition-open - so we're esentially loading everything twice.
        ;; Using .pushState would be better, since it won't trigger the transition-open, and loads the content only once - but we 
        ;; won't go live with it until the history issue is resolved. 
         #_(-> js/window .-history
             (.pushState #js {} "" (str/replace (urlstate/url (str "/" (:base (:url-navigation e)) ".htm") (:params (:url-navigation e))) "%20" "+")))))))

(defmethod grid/action :search/revert-filter [app-atom config]
  (let [process-atom (cmn/action-cursor app-atom)
        original-navigation (cmn/curact process-atom [:original-navigation])]

    (swap! (cmn/process-cursor app-atom) assoc
      :navigation original-navigation)))

;; Sorting =============================================================================================================
(rum/defc sorting < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:search/keys [search-category result-size searchstr]} (cmn/curact process-atom [:search])
        navigation-sort (rum/cursor-in process-atom [:navigation :navigation/sort])
        search-columns (if (= result-size 20) 4 6)

        sort-options
        [{:value "popularity" :text "Popularity"}
         {:value "rating" :text "Rating"}
         {:value "pricelow" :text "Price (Lowest)"}
         {:value "pricehigh" :text "Price (Highest)"}
         {:value "added" :text "Latest"}
         {:value "wishlist" :text "Most Wishlisted"}
         {:value "gifted" :text "Most Gifted"}]]

    [:div
     {:class (u/bem :flex-grid-block [:t-1-2 :ml-fluid])}
     [:div.flex-grid-content
      [:div
       {:class (u/bem :flex-grid-group [:valign-bottom])}
       [:div
        {:class (u/bem :flex-grid-block [:fluid :grow-yes :ml-fluid])}
        [:div.flex-grid-content
         [:label.filter-bar-label {:for "search-sorting"} "Sort by:"]
         (forms/select-raw navigation-sort
           (cond
             searchstr
             (concat
               [{:value "score" :text "Relevance"}]
               sort-options)

             :else
             sort-options)
           {:sort? true
            :id "search-sorting"
            :change-fn
            #(grid/dispatch-action app-atom :search/sort {})})]]

       (when-not (= (:carddisplay (:category/lookfeel search-category)) "list")
         [:div
          {:class (u/bem :flex-grid-block [:l-fluid :l-show :hide])}
          [:a.js-grid-button
           (merge
             (urlstate/href-on-click #(grid/dispatch-action app-atom :search/result-size {}))
             {:class (u/bem :button [:has-icon-only :bordered :secondary :flat-to-raised :default])})
           [:span.button__text
            [:i.button__icon.js-grid-icon
             {:class (u/bem :icon [(if (= search-columns 4) :grid-default :grid-small) :is-dark :default :block])}
             [:span.u-hidden-from-view "Display more"]]]]])]]]))


(defmethod grid/action :search/sort [app-atom config]
  (toaster/open-overlay app-atom :search/results)
  (let [search-config (build-search-config app-atom config)
        transformed-params (transform-send-params (dissoc (:params search-config) :page))]

    (comms/ajax-post :web.search/apply-filter (assoc search-config :params transformed-params))))

(defmethod grid/action :search/result-size [app-atom config]
  (toaster/open-overlay app-atom :search/results)
  (let [search-config (build-search-config app-atom config)
        rows (if (= (:rows (:params search-config)) 20) 24 20)
        transformed-params
        (->
          (:params search-config)
          (dissoc :page)
          (assoc :rows rows)
          (transform-send-params))]

    (u/set-cookie! app-atom :num-search-rows rows)
    (comms/ajax-post :web.search/apply-filter (assoc search-config :params transformed-params))))

(rum/defc filter-bar-item [app-atom {:keys [filter-key filter-name additional-classes additional-hidden-text]}]
  [:li.filter-bar__item
   {:class (u/bem :filter-bar__item (if additional-classes additional-classes []))}
   [:a.filter-bar-button
    (merge
      (urlstate/href-on-click #(grid/dispatch-action app-atom :search/filter-popup (if filter-key {:filter-key filter-key} {})))
      {:class (u/bem :button [:default :has-icon-right])})
    [:span.button__text
     [:span.u-hidden-from-view "Filter by "]
     filter-name
     (when additional-hidden-text
       [:span.u-hidden-from-view additional-hidden-text])
     [:i.button__icon
      {:class (u/bem :icon [:default :block :is-dark :chevron-down])}]]]])

;; Search Page =========================================================================================================
(rum/defc results < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:ent/keys [display-name]
         :search/keys [searchstr search-category search-suggestions result-size products breadcrumbs]}
        (cmn/curact process-atom [:search])

        remove-filters (cmn/curact process-atom [:navigation :navigation/remove-filters])
        navigation-filters (cmn/curact process-atom [:navigation :navigation/filters])
        show-category-filter? (not (:hide? (:category navigation-filters)))
        show-brand-filter? (not (:hide? (:brand navigation-filters)))
        show-price-filter? (not (:hide? (:price navigation-filters)))
        search-columns (if (= result-size 20) 4 6)
        navigation-pagination (rum/cursor-in process-atom [:navigation :navigation/pagination])
        has-result? (not (nil? (cmn/curact process-atom [:navigation :navigation/result-count])))
        result-count (or (cmn/curact process-atom [:navigation :navigation/result-count]) 0)
        {:keys [pages]} (rum/react navigation-pagination)
        pagecount (u/ceil (/ result-count (or (:pagesize pages) 1)))
        banner (first (cmn/curact process-atom :search-banners))
        dark-text (boolean (:text_dark banner))

        feature-filters
        (not-empty
          (filter
            #(feature-key? %)
            (keys navigation-filters)))]

    [:div
     {:id :main-content
      :class (u/bem :yc-page-content [:medium])}
     (when banner
       [:div
        {:class (u/bem :yc-section [:standard])}
        [:a.u-block-link
         {:class (u/bem :card [:is-flex-column :no-border] :text-card [:small] (keyword (str "u-bg-" (:colour_name banner))))
          :href (:url banner)
          :on-click
          (fn [e]
            (.preventDefault e)
            (grid/dispatch-action app-atom :web.footer/save-banner-click {:banner banner}))}
         [:p.u-text-center {:class (u/bem :yc-paragraph [:small :flush] (when-not dark-text :u-text-white))}
          [:i {:class (u/bem :icon [:inline :in-copy :small (if dark-text :is-light :is-dark)])}]
          [:b (:title banner)]
          " "
          [:span
           {:dangerouslySetInnerHTML
            {:__html (:description banner)}}]
          " "
          [:span.u-text-underline (:buttontext banner)]]]])

     (when-not has-result?
       [:section
        {:class (u/bem :yc-section [:large])}
        (toaster/loading-overlay app-atom :search/results)])

     (when (> result-count 0)
       [:section
        {:class (u/bem :yc-section [:large])}
        (headings/heading display-name {:type :h1 :size :default :center true})

        (when-not (or (nil? search-category) (nil? breadcrumbs) (empty? breadcrumbs))
          [:ul.u-margin-bottom-20
           {:class (u/bem :breadcrumbs [:centered :search])}
           (let [first-crumb (first breadcrumbs)
                 rest-crumbs (drop 1 breadcrumbs)]
             (list
               [:li
                {:key (:breadcrumb/base first-crumb)
                 :class (u/bem :breadcrumbs__item [:always-show])}
                [:a.breadcrumb__link
                 (if (:breadcrumb/link? first-crumb)
                   (urlstate/href-props app-atom (:breadcrumb/base first-crumb))
                   (urlstate/href-on-click #(grid/dispatch-action app-atom :search/filter-popup {})))
                 [:span.unclip-text--s.clip-text--m
                  [:i {:class (u/bem :icon [:arrow-left :tiny :inline])}]
                  " Back to "]
                 (:ent/display-name first-crumb)]]

               (map
                 (fn [i]
                   [:li.breadcrumbs__item
                    {:key (:breadcrumb/base i)}
                    [:a.breadcrumb__link
                     (if (:breadcrumb/link? i)
                       (urlstate/href-props app-atom (:breadcrumb/base i))
                       (urlstate/href-on-click #(grid/dispatch-action app-atom :search/filter-popup {})))
                     (:ent/display-name i)]])
                 rest-crumbs)))])

        [:nav
         {:id :search-results
          :class
          (u/bem
            :flex-grid-group
            [:valign-bottom :s-align-between :align-center])}
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2 :ml-fluid])}
          [:div.flex-grid-content
           [:div.filter-bar-nav
            [:div.filter-bar-heading-wrapper
             [:small.filter-bar-label {:aria-hidden "true"} "Refine results:"]
             [:div.filter-bar-heading-wrapper
              [:h3.filter-bar-heading
               [:a
                (merge
                  (urlstate/href-on-click #(grid/dispatch-action app-atom :search/filter-popup {}))
                  {:class (u/bem :filter-bar-button [:is-heading] :button [:has-icon-left :default])})
                [:span.button__text
                 [:i.button__icon
                  {:class (u/bem :icon [:filter :is-dark :default :block])}]
                 "Filter"
                 [:span.clip-text--ml {:aria-hidden "true"} "s"]
                 [:span.clip-text.unclip-text--ml " by:"]]]]
              (when (> (count remove-filters) 0)
                [:small.filter-bar-count
                 (count remove-filters)
                 [:span.u-hidden-from-view " active filters"]])]]


            [:ul.filter-bar
             (when show-category-filter?
               (filter-bar-item app-atom {:filter-key :category :filter-name "Category"}))
             (when show-brand-filter?
               (filter-bar-item app-atom {:filter-key :brand :filter-name "Brand"}))
             (when feature-filters
               (filter-bar-item app-atom {:filter-key :features :filter-name "Features"}))
             (when show-price-filter?
               (filter-bar-item app-atom {:filter-key :price :filter-name "Price" :additional-classes [:ml-hide :l-show]}))
             (filter-bar-item app-atom {:filter-name "More" :additional-hidden-text " options"})]]]]

         (sorting app-atom)]

        (when (not-empty search-suggestions)
          [:aside
           {:class (u/bem :flex-grid-group [:align-left])}
           [:div
            {:class (u/bem :flex-grid-block [:full])}
            [:div.flex-grid-content
             [:p.suggested-phrases
              [:span.suggested-phrases__title "Related customer searches:"]
              (map
                (fn [suggestion]
                  [:a.suggested-phrases__button
                   (merge
                     (urlstate/href-props app-atom "search" nil {:origin "PopularSearches" :searchstr suggestion})
                     {:key suggestion
                      :class (u/bem :button [:bordered :secondary :rounded :raised :small])})

                   [:span.button__text suggestion]])
                search-suggestions)]]]])
        [:div
         {:class (u/bem :flex-grid-group [:align-left])}
         (map
           (fn [product]
             [:div.js-flex-grid-block
              {:key (:product/id product)
               :class
               (u/bem :flex-grid-block
                 (if (= (:carddisplay (:category/lookfeel search-category)) "list")
                   [:t-1-1]
                   [(if (= search-columns 4) :ml-1-4 :ml-1-6) :t-1-2]))}
              (if (= (:carddisplay (:category/lookfeel search-category)) "list")
                (cards/product-card-large app-atom product)
                (cards/product-card-default app-atom product {:small? (= search-columns 6)}))])
           products)]

        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:t-full])}
          [:div.flex-grid-content
           (web-common/pagination-control app-atom (rum/cursor navigation-pagination :pages) pagecount
             {:navigate :url
              :scroll-to "search-results"
              :grid-action :search/paginate
              :loading-overlay :search/results
              :show-summary? true
              :result-count result-count})]]]
        (toaster/loading-overlay app-atom :search/results)])

     (when
       (and has-result? (= result-count 0))
       [:div
        {:class (u/bem :yc-section [:standard])}
        [:section
         [:div.flex-grid-content
          (headings/heading
            (if (u/presence searchstr)
              (str "No search results for \" " (str/replace searchstr "+" " ") "\"")
              "No search results for your criteria")
            {:type :h1 :size :medium :center true})
          [:div.u-block-center.u-max-width-720
           [:p.yc-paragraph.u-text-center "Please check the spelling or try a slightly different phrase, using as few words as possible."]
           [:div.u-block-center.u-max-width-480
            [:div.flex-grid-group.flex-grid-group--flush.flex-grid-group--flush-force
             [:div.flex-grid-block.flex-grid-block--m-1-2
              [:div.flex-grid-content
               (buttons/button-web "Shop all products" {:href "/products.htm" :style :secondary :size :default :full true})]]
             [:div.flex-grid-block.flex-grid-block--m-1-2
              [:div.flex-grid-content
               (buttons/button-web "Shop latest products" {:href "/latest.htm" :style :primary :size :default :full true})]]]]]]]])]))

(defmethod flow/render-screen :web.search [app-atom _]
  (website/screen-wrapper app-atom
    (results app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.search [app-atom _ params]
  (let [transformed-params (transform-send-params params)
        cookies (get-in @app-atom [:page :cookies])
        rows (u/parseInt (:num-search-rows cookies))
        app-page (cmn/curact app-atom [:page])
        {:keys [params base]} ((:screen app-page) app-page)]

    (toaster/open-overlay app-atom :search/results)

    (if (and (= base "search") (not (u/presence (:searchstr params))))
      (urlstate/redirect app-atom "products" nil)
      (comms/ajax-post :web.search/products
        {:banner-data
         (u/maybe assoc
           {:banner-type "bar message"
            :limit 1
            :page (str "/" (cmn/page-base-url app-atom) ".htm")}
           :mobile? (cmn/curact app-atom [:mobile?]))
         :params (assoc transformed-params :rows (if (> rows 0) rows 20))}))))

(defmethod comms/receive :web.search/products [app-atom e]
  (let [app-page (cmn/curact app-atom [:page])
        {:keys [params base]} ((:screen app-page) app-page)
        {:search/keys [result-size max-pages page-number page-meta-title]} (:search e)
        {:navigation/keys [result-count]} (:navigation e)]

    (if (and (> result-count 0) (> result-size 0) (> page-number max-pages))
      (urlstate/redirect app-atom base nil (assoc params :page (u/parseInt max-pages)))
      (swap-atom-search-results app-atom e))

    #?(:cljs
       (when (u/presence page-meta-title)
         (set! (. js/document -title) page-meta-title)))

    (toaster/close-overlay app-atom :search/results)))

(defmethod grid/action :search/paginate [app-atom config]
  (let [search-config (build-search-config app-atom config)

        transformed-params
        (transform-send-params (assoc (:params search-config) :page (:page config)))]

    (comms/ajax-post :web.search/apply-filter
      (assoc search-config :params transformed-params))))

(defmethod grid/action :search/search-click-stats [app-atom stats]
  (comms/ajax-get :web.search/stats
    {:stats (assoc stats :mobile? (get-in @app-atom [:device :mobile?]))}))

(defmethod comms/receive :web.search/stats [app-atom e])
